'use client'
import { useTorContext } from 'utils/context'

const Formacio = () => {
  const { tor } = useTorContext()
  return (
    <div className="bg-[#f2f3f3] pt-20">
      <div className="relative block h-[2000px] lg:h-[1500px] overflow-hidden">
        <iframe
          src={`https://${
            process.env.NEXT_PUBLIC_STAGE !== 'pro'
              ? 'fcpadel.iberowan.com'
              : 'gestio.fcpadel.cat'
          }/ligas_editaEquipoX.aspx?delegacion=&IdTorneo=${tor.Info.Id}&tipo=`}
          className="absolute top-0 bottom-0 left-0 w-full h-full"
        ></iframe>
      </div>
    </div>
  )
}

export default Formacio
